<template>
  <div>
    <div hidden>
      <h4>Доступно реестров для вывоза отхода:</h4>
      <h4>Доступно для захоронения</h4>
      <p>Максимальное значение: 0.0 шт. (штук)</p>
      <p>Текущее значение: 0.0 шт. (штук)</p>
      <h4 style="color: red">Заполненность: 100 %</h4>
    </div>

    <el-form
      :model="buriedForm"
      ref="formedForm"
      :rules="rules"
      label-position="top"
      label-width="120px"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item prop="date" label="Дата">
            <el-date-picker
              @change="setDatastored"
              value-format="yyyy-MM-dd"
              format="dd.MM.yyyy"
              v-model="buriedForm.date"
              type="date"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="ammount" label="" v-if="datastored !== null">
            Доступно на {{ buriedForm.date }} для проведения операции:
            {{ datastored.amount - datastored.sumAmountGet }}
            {{ datastored.pss93UnitInfo.name }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-row>
            <el-form-item prop="store" label="Количество">
              <el-input 
                v-model="buriedForm.store" 
                @input="buriedForm.store = buriedForm.store.replace(/[^0-9.,]/g, '')"
                :min="0"/>
            </el-form-item>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Единица измерения">
            <el-input v-model="waste.pss93UnitInfo.name" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <p
          style="color: red"
          v-if="
            datastored !== null &&
            parseFloat(buriedForm.store.toString().replace(',', '-')) >
              valueDatastor + 0.001
          "
        >
          Ошибка! Превышение доступного количества отхода
        </p>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item prop="pss21Info" label="Объекты захоронения отходов">
            <el-select
              clearable
              placeholder="Объект захоронения"
              class="searchPole"
              value-key="id"
              v-model="buriedForm.pss21Info"
              filterable
            >
              <el-option
                v-for="item in pss21BurialObjectInfoList"
                :key="item.id"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-button
            @click="passportAdd"
            type="primary"
            style="float: left"
            :disabled="
              parseFloat(buriedForm.store.toString().replace(',', '-')) >
                valueDatastor + 0.001 ||
              block ||
              GETISDATEENTRYLOCKED(buriedForm.date)
            "
            >Сопроводительный паспорт</el-button
          >
        </el-col>
        <el-col :span="4">
          <el-button
            @click="save"
            type="primary"
            style="float: right"
            :disabled="
              parseFloat(buriedForm.store.toString().replace(',', '-')) >
                valueDatastor + 0.001 ||
              block ||
              GETISDATEENTRYLOCKED(buriedForm.date)
            "
            >Сохранить</el-button
          >
        </el-col>
      </el-row>
    </el-form>

    <custom-modal :visible="showModal === 'dataPasport'">
      <disposal-pasport-form
        :action="passport"
        :waste="wastes"
        @addPasportToTable="addPasportToTable"
      ></disposal-pasport-form>
    </custom-modal>
  </div>
</template>

<script>
import notification from "@/mixins/notification";
import Cookies from "js-cookie";
import CustomModal from "@/components/customModal";
import { mapGetters } from "vuex";
import disposalPasportForm from "@/components/ecologist/disposal/disposalPasport";
import { AXIOS } from "@/AXIOS/http-common";
export default {
  name: "buriedModal",
  components: { disposalPasportForm, CustomModal },
  props: ["waste"],
  mixins: [notification],
  data() {
    return {
      pickerOptions:{
        firstDayOfWeek: 1
      },
      passport: {
        number: null,
        contractor1: null,
        contractor2: { content: 0 },
        contractor3: null,
        data: null,
        vehicle: null,
        full_name: null,
        tara_name: null,
        tara_vight: null,
        vehicle_vight: null,
        number_card: null,
        owner: null,
        ownerr: null,
        transfer: null,
        transferr: null,
        ca1: "Ручной ввод",
        contractor1r: null,
        ca2: "Ручной ввод",
        contractor2r: null,
        ca3: "Ручной ввод",
        contractor3r: null,
        egr_full_name: null,
        chek_null_value: false,
        fileType: ".pdf",
        modal: "dataEntry",
        tr: "Ответственное лицо",
        ow: "Ответственное лицо",
        rules: {
          rul: [{ required: true, message: "Заполните поле", trigger: "blur" }],
        },
      },
      wastes: null,
      userId: Cookies.get("userId"),
      block: false,
      valueDatastor: 0,
      dateDatastore: null,
      pss21BurialObjectInfoList: null,
      datastored: null,
      actionId: 6,
      buriedForm: {
        amount: this.waste.amount,
        store: "0",
        date: "",
        pss21Info: null,
      },
      rules: {
        pss21Info: [
          { required: true, message: "Заполните поле", trigger: "blur" },
        ],

        store: [{ required: true, message: "Заполните поле", trigger: "blur" }],

        date: [{ required: true, message: "Введите дату", trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapGetters({
      showModal: "GETSHOWMODAL",
      listContractors: "GETLISTCONTRACTORS",
      NumberPassport: "GETDATASTORED",
      GETISDATEENTRYLOCKED: "GETISDATEENTRYLOCKED",
    }),
  },

  methods: {
    getPss21BurialObjectInfoList() {
      this.getSubClassifierById(21).then((response) => {
        this.pss21BurialObjectInfoList = response.data.content;
      });
    },

    async getSubClassifierById(id) {
      let data = {
        id: id,
        size: 100,
        page: 0,
      };
      return await this.$store.dispatch(
        "getAllDataSubClassifierForSelect",
        data
      );
    },
    async setDatastored() {
      await this.$store.dispatch("getBlockForUser",this.buriedForm.date).then((response) => {
        if(response.data == true)
          {
            this.block=true;
            this.message(
              "Внимание! Заблокировано главным экологом!",
              "error",
              true
            );
            return;
          }

      if (this.GETISDATEENTRYLOCKED(this.buriedForm.date))
        this.message(
          "Внимание! Внесение данных за " +
            new Date(this.validat().item.date).getFullYear() +
            " год ограничено. Закрыт отчетный период",
          "error",
          true
        );
      this.getDatastored().then((response) => {
        if (response.data == true) {
          this.block = true;
          this.message("Внимание! Цепочка устарела!", "error", true);
          return;
        }
        if (response.data == false) {
          this.block = true;
          this.message(
            "Внимание! Цепочка не начала действовать!",
            "error",
            true
          );
          return;
        }
        this.block = false;
        this.datastored = response.data;
        this.valueDatastor =
          this.datastored.amount - this.datastored.sumAmountGet;
        this.dateDatastore = Date.parse(response.data.path);
        if (this.dateDatastore > Date.parse(this.buriedForm.date, "yyyy-MM-dd"))
          this.message(
            "Внимание! Внесение информации на данной вкладке приведет к перерасчету количества отходов и изменениям в отчетной документации. Будьте внимательны при заполнении!",
            "error",
            true
          );
      });
      
      });
    },
    async getDatastored() {
      let data = { date: "", techProcessHasWasteId: "" };
      data.date = this.buriedForm.date;
      data.techProcessHasWasteId = this.waste.techProcessHasWasteId;
      return await this.$store.dispatch("getDataStored", data);
    },
    validat() {
      let i = 0;
      if (this.buriedForm.date == "" || this.buriedForm.store == "")
        //{this.ErrorMasseg("Внимание! Заполните всте поля");
        i = 1;
      if (this.GETISDATEENTRYLOCKED(this.buriedForm.date))
        //{this.ErrorMasseg("Внимание! Дата одного из значений меньше чем "+new Date().getFullYear()+" год");
        i = 2;
      return { id: i, item: this.buriedForm };
    },
    async GetNumberPassport() {
      return await AXIOS.get("report/get/NumberPass").then((response) => {
        this.passport.number = response.data.numb;
        this.passport.egr_full_name = response.data.egr_full_name;
        this.passport.contractor1r = response.data.egr_full_name;
        this.passport.contractor2r = response.data.egr_full_name;
        this.passport.contractor3r = response.data.egr_full_name;
      });
    },
    async passportAdd() {
      await this.GetNumberPassport();
      this.passport.data =
        this.buriedForm.date.split("-")[2] +
        "." +
        this.buriedForm.date.split("-")[1] +
        "." +
        this.buriedForm.date.split("-")[0];
      //if (item.Contractors !== undefined)
      this.$store.dispatch("setShowModal", "dataPasport");
    },
    addPasportToTable(item) {
      console.log(this.showModal);
      this.passport = item;
      this.buriedForm.passport = item; //.action;
      //this.wastes[0]=item.wastes;
      this.save();
    },
    save() {
      switch (this.validat().id) {
        case 1:
          this.ErrorMasseg("Внимание! Заполните все поля");
          return;
        case 2:
          this.ErrorMasseg(
            "Внимание! Внесение данных за " +
              new Date(this.validat().item.date).getFullYear() +
              " год ограничено. Закрыт отчетный период"
          );
          return;
        case 0:
          break;
      }
      this.$refs["formedForm"].validate((valid) => {
        if (valid) {
          
          this.block = true;
          this.buriedForm.amount = this.waste.amount;
          console.log("VALID", this.buriedForm);
          this.$store
            .dispatch("receiveDataEntryForm", {
              modalData: this.buriedForm,
              id: this.$route.params.processId,
              actionId: this.actionId,
            })
            .then(() => {
              this.$store.dispatch(
                "getMainPageForDataEntry",
                this.$route.params.processId
              );
              this.$store.dispatch(
                "getMainPageForDataEntryByPeriod",
                this.$route.params.processId
              );
              this.notification("Успешно", "Данные внесены", "success");
              this.$store.dispatch("setShowModal", null);
              this.$store.dispatch("setShowModal", false);
            })
            .catch(error => {
              this.block = false;
              console.log(error.statusText);
            });
        } else {
          return false;
        }
      });
    },
  },

  mounted() {
    this.getPss21BurialObjectInfoList();
  },
};
</script>

<style scoped></style>
